<template>
  <div class="mobile-payments">
      <div class="section">
        <div class="container">
          <div>
            <h2>有料プラン申込</h2>
            <div class="main-area">
              <ul>
                <li>1契約</li>
                <li>約<span class="price-large">460</span>円/月</li>
                <li>年額<span class="price-normal">5,500</span>円 (税込)</li>
              </ul>
            </div>
            <div class="sub-area">
              <div class="agree-area">
                <dl class="columns td-check">
                  <label for="box1">
                    <input id="box1" type="checkbox" v-model="agreement1"/>
                    <span class="checkbox-text"></span>
                  </label>
                  <div>
                    <a
                      href="https://www.ricelog.com/service.html"
                      target="_blank"
                      rel="noopener"
                    >
                      利用規約
                    </a>
                    に同意する。
                  </div>
                </dl>
                <dl class="columns td-check" style="margin-top: 1rem;">
                  <label for="box2">
                    <input id="box2" type="checkbox" v-model="agreement2"/>
                    <span class="checkbox-text"></span>
                  </label>
                  <div>
                   <a
                      href="https://www.sglabs.jp/privacy-policy/"
                      target="_blank"
                      rel="noopener"
                    >
                      プライバシーポリシー
                    </a>
                    および
                    <a
                      href="https://www.ricelog.com/privacy.html"
                      target="_blank"
                      rel="noopener"
                    >
                      個人情報の取扱いについて
                    </a>
                    に同意する。
                  </div>
                </dl>
                <dl class="columns">
                  <span style="margin-top: 1rem;">
                  お支払い方法、お支払時期、解約については<a
                    href="https://www.ricelog.com/sct.html"
                    target="_blank"
                    >こちら</a
                  >をご確認ください。
                  </span>
                </dl>
              </div>
            </div>
            <div
              id="message-area"
              class="error-message mdi mdi-alert-circle-outline"
              v-if="errorMessage"
            >
              {{ errorMessage }}
            </div>
            <div
              id="message-area"
              class="information-message mdi mdi-check-circle-outline"
              v-if="message"
            >
              {{ message }}
            </div>
            <div class="card-area" :class="{ 
              complete: cardInput,
              'ex-card-area-disable': !(agreement1 && agreement2) 
            }">
              <div ref="payjpArea"></div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";
import { PAYMENT, PAYMENT_RESULT_CODE, MENU_CODE, OPERATION_TYPE } from "@/constants/constants";
import Contract from "@/mixins/contract";

export default {
  props:{

  },

  data() {
    return {
      cardInput: false,
      errorMessage: null,
      message: null,
      agreement1 : false,
      agreement2 : false,
    };
  },

  mixins: [Loader, Contract],
  components: {},
  created() {},

  mounted() {
    this.loading(async () => {
      this.cardInput = false;
      this.appendPayJpScriptTag();
      window.onTokenCreated = this.onTokenCreated;
      window.onTokenFailed = this.onTokenFailed;
      document.getElementById('container').scrollIntoView({
          behavior: 'instant',
          block: 'start'
      });
      await this.accessLogs({
        menu: MENU_CODE.PAYMENT,
        ope: OPERATION_TYPE.Menu,
      });
    });
  },

  beforeDestroy() {
    try {
      this.destoryPayjp();
    } catch(e) {
      console.log(e);
    }
  },

  methods: {
    ...mapActions(["createSubscription", "accessLogs"]),
    ...mapGetters(["getAccountID"]),

    appendPayJpScriptTag() {
      const attrs = {
        "data-payjp-key": PAYMENT.KEY,
        id: "payjp-script",
        src: "https://checkout.pay.jp/",
        class: "payjp-button",
        "data-payjp-text": "有料プラン申込",
        "data-payjp-submit-text": "有料プラン申込",
        "data-payjp-lang": "ja",
        "data-payjp-token-name":"payjp-token",
        "data-payjp-three-d-secure":"true",
        "data-payjp-three-d-secure-workflow":"subwindow",
        "data-payjp-extra-attribute-email":"",
        "data-payjp-extra-attribute-phone":"",
        "data-payjp-extra-attribute-phone-code":"JP",
        "data-payjp-partial":"true",
        "data-payjp-on-created":"onTokenCreated",
        "data-payjp-on-failed":"onTokenFailed",
      };
      this.scriptEl = document.createElement("script");
      for (let key in attrs) {
        this.scriptEl.setAttribute(key, attrs[key]);
      }
      this.$refs.payjpArea.appendChild(this.scriptEl);
    },
    onTokenCreated() {
      this.loading(async () => {
        let token = document.getElementsByName("payjp-token")[0].value;
        this.errorMessage = null;
        this.message = null;
        this.cardInput = true;
        try {
          const ret = await this.createSubscription({ token: token });
          if (ret.status === 201) {
            this.message = "既に申込済みです。";
            this.$router.push({ name: "mobile-payment-complete", params:{result: PAYMENT_RESULT_CODE.Already, message: this.message} });
          } else {
            this.message = "申込が完了いたしました。";
            this.$router.push({ name: "mobile-payment-complete", params:{result: PAYMENT_RESULT_CODE.Success, message: this.message} });
          }
        } catch (err) {
          this.errorMessage =
            "申込ができませんでした。再度申込を行なってください。";
          this.$router.push({ name: "mobile-payment-complete", params:{result: PAYMENT_RESULT_CODE.Error, message: this.errorMessage} });
        }
      });
    },
    onTokenFailed(res) {  // eslint-disable-line no-unused-vars
      // 処理
      this.errorMessage =
        "カード情報の読み込みに失敗しました。再度申込を行なってください。";
      this.cardInput = false;
    },

    onAddSubscription() {},

    destoryPayjp() {
      const payjpCheckoutIframeEl = document.getElementById(
        "payjp-checkout-iframe"
      );
      if (payjpCheckoutIframeEl) {
        payjpCheckoutIframeEl.parentElement.remove();
      }
      try {
        this.$refs.payjpArea.removeChild(this.scriptEl);
      } finally {
        window.PayjpCheckout = null;
        window.onTokenCreated = null;
        window.onTokenFailed = null;
      }
    },
  },
};
</script>

<style lang="scss">
.mobile-payments {
  .section {
    overflow: auto;
    width: 100%;
    height: 100%;
    position: relative;
    margin: auto;
    background: white;

    .container {
      margin: 2rem;

      h2 {
        text-align: center;
        font-weight: 400;
      }

      .main-area {
        text-align: center;
        font-size: 1.5rem;

        .price-large {
          font-size: 3rem;
          margin: 1rem;
        }
        .price-normal {
          font-weight: 700;
          margin: 0.5rem;
        }
      }

      .main-area ul {
        list-style-type: none;
        padding-inline: unset;
      }

      .main-area a {
        margin: 0.5rem;
      }

      .sub-area {
        margin-top: 1rem;

      }
      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: auto;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        color: #333;
      }
      dl.columns.td-check {
          grid-template-columns: 40px auto;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 16px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 16px;

        &.input-with-unit {
          display: flex;
          align-items: center;
          .unit {
            margin-left: 1rem;
            word-break: keep-all;
          }
        }
      }
      .columns dt:nth-of-type(odd) {
        background: #f3f3f3;
      }
      .columns dd:nth-of-type(odd) {
        background: #f3f3f3;
      }

      input[type="checkbox"] {
        display: none;
      }

      input[type="checkbox"] + span {
        display: block;
        height: 24px;
        width: 24px;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
      }
      input[type="checkbox"]:checked + span:after {
        display: block;
        height: 24px;
        width: 24px;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
      }
    }
  }
  .card-area {
    text-align: center;
    margin-top: 2rem;
  }
  .card-area.complete {
    display: none;
  }
  #payjp_checkout_box input[type="button"] {
    font-size: 16px;
  }
  #message-area {
    margin-top: 2rem;
  }

  .ex-card-area-disable {
    opacity: 0.5;
    pointer-events: none;
    cursor: none;
  }
}
</style>
